import {ChangeDetectionStrategy, Component, computed, effect, Injectable, input, signal, viewChild} from '@angular/core';
import {MatButtonModule} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {TranslateModule} from "@ngx-translate/core";
import {GruppeId, TemaModell, TemaRessursClient} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {GruppeTemaRedigerListeKomponent} from "../gruppe-tema-rediger-liste/gruppe-tema-rediger-liste";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {KortKomponent} from "web-ng2/delt/komponenter/kort/kort";
import {KortTittelKomponent} from "web-ng2/delt/komponenter/kort/kort-tittel/kort-tittel";
import {KortHandlingerKomponent} from "web-ng2/delt/komponenter/kort/kort-handlinger/kort-handlinger";
import {HtmlFormatertKomponent} from "web-ng2/delt/komponenter/html-formatert/html-formatert";

const debug = initDebugger('GruppeTemaerKomponent');

@Component({
    selector: 'gruppe-temaer',
    templateUrl: 'gruppe-temaer.html',
    styleUrl: 'gruppe-temaer.scss',
    host: {'data-testid': 'temaer'},
    imports: [
        GruppeTemaRedigerListeKomponent,
        MatButtonModule,
        MatIcon,
        TranslateModule,
        KortKomponent,
        KortTittelKomponent,
        KortHandlingerKomponent,
        HtmlFormatertKomponent,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GruppeTemaerKomponent {

    kortKomp = viewChild.required(KortKomponent);

    gruppeId = input.required<GruppeId>();

    temaer = signal<TemaModell[]>([]);
    aktiveTemaer = computed(() => this.temaer().filter(t => !t.arkivert));
    arkiverteTemaer = computed(() => this.temaer().filter(t => t.arkivert));

    viserArkiverteTemaer = signal(false);
    visning = signal(true);

    constructor(private avhengigheter: GruppeTemaerKomponentAvhengigheter) {
        effect(() => {
            debug('laster temaer for', this.gruppeId());
            this.avhengigheter.hentTemaer(this.gruppeId())
                .then(t => this.temaer.set(t));
        });
    }

    visDetaljer() {
        this.kortKomp().setSomAktivOgSkrollTil();
    }

    skjulDetaljer() {
        this.viserArkiverteTemaer.set(false);
        this.kortKomp().setSomIkkeAktiv();
    }

    rediger() {
        this.visning.set(false);
        this.kortKomp().skrollTil();
    }

    redigeringFerdig(oppdaterteTemaer: TemaModell[] | null) {
        if (oppdaterteTemaer !== null) {
            this.temaer.set(oppdaterteTemaer);
        }
        this.visning.set(true);
        this.viserArkiverteTemaer.set(false);
        this.kortKomp().skrollTil();
    }
}

@Injectable()
export class GruppeTemaerKomponentAvhengigheter {

    constructor(private temaRessurs: TemaRessursClient) {
    }

    hentTemaer(gruppeId: GruppeId): Promise<TemaModell[]> {
        return this.temaRessurs.finnAlle(gruppeId).somPromise();
    }
}
